import { Loader2, AlertTriangle, Inbox } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const Loading = ({ label = "Caricamento..." }) => (
  <div className="flex flex-col items-center justify-center py-20 text-muted-foreground" data-testid="loading-state">
    <Loader2 className="h-8 w-8 animate-spin text-primary" />
    <p className="mt-3 text-sm">{label}</p>
  </div>
);

export const ErrorState = ({ message, onRetry }) => (
  <Card className="border-destructive/30 bg-destructive/5" data-testid="error-state">
    <CardContent className="flex flex-col items-center py-10 text-center">
      <AlertTriangle className="h-8 w-8 text-destructive" />
      <p className="mt-3 text-sm text-foreground/80">{message}</p>
      {onRetry && (
        <Button variant="outline" className="mt-4" onClick={onRetry} data-testid="retry-button">
          Riprova
        </Button>
      )}
    </CardContent>
  </Card>
);

export const EmptyState = ({ title = "Nessun dato", subtitle }) => (
  <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border py-16 text-center" data-testid="empty-state">
    <div className="rounded-full bg-muted p-4">
      <Inbox className="h-7 w-7 text-muted-foreground" />
    </div>
    <p className="mt-4 font-semibold">{title}</p>
    {subtitle && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{subtitle}</p>}
  </div>
);

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="text-3xl font-semibold text-foreground sm:text-4xl">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const StatCard = ({ icon: Icon, label, value, tint = "primary", testId }) => (
  <Card className="overflow-hidden border-border/70 transition-all hover:-translate-y-0.5 hover:shadow-md" data-testid={testId}>
    <CardContent className="flex items-center gap-4 p-5">
      <div className={`grid h-12 w-12 place-items-center rounded-2xl bg-${tint}/10 text-${tint}`}>
        {Icon && <Icon className="h-6 w-6" />}
      </div>
      <div>
        <p className="text-2xl font-bold leading-tight">{value ?? "—"}</p>
        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
      </div>
    </CardContent>
  </Card>
);
